"use strict";
var CookieMonsterService = (function () {
    /* @ngInject */
    function CookieMonsterService(API_URL, $http) {
        this.API_URL = API_URL;
        this.$http = $http;
    }
    CookieMonsterService.prototype.getAll = function (cache) {
        if (cache === void 0) { cache = true; }
        return this.$http.get("" + this.API_URL.cookieMonster, { cache: cache })
            .then(function (response) {
            return response.data;
        });
    };
    CookieMonsterService.prototype.get = function (key, cache) {
        if (cache === void 0) { cache = true; }
        return this.$http.get(this.API_URL.cookieMonster + "/" + key, { cache: cache })
            .then(function (response) {
            return response.data;
        })
            .catch(function () { return null; });
    };
    CookieMonsterService.prototype.set = function (key, value) {
        return this.$http.post("" + this.API_URL.cookieMonster, {
            key: key,
            value: value
        })
            .then(function (response) {
            return response.data;
        });
    };
    CookieMonsterService.prototype.delete = function (key) {
        return this.$http.delete(this.API_URL.cookieMonster + "/" + key)
            .then(function (response) {
            return response.data;
        });
    };
    return CookieMonsterService;
}());
exports.CookieMonsterService = CookieMonsterService;



/** WEBPACK FOOTER **
 ** ./app/cookie-monster/cookie-monster.service.ts
 **/